import { sanitizeOrganizationId } from "@core/configuration";
import { OrganizationLocalStorage } from "./OrganizationLocalStorage.js";
import { OrganizationSelectors } from "./selectors/OrganizationSelectors.js";
import { OrganizationStore } from "./store/OrganizationStore.js";
var EXTRACT_ORG_ID_FROM_URL_HASH = /#\/(\w+)/;
var getId = function() {
    var ref;
    return OrganizationSelectors.getOrganizationId(OrganizationStore.getState()) || sanitizeOrganizationId((ref = EXTRACT_ORG_ID_FROM_URL_HASH.exec(window.location.hash)) === null || ref === void 0 ? void 0 : ref[1]) || OrganizationLocalStorage.getOrganizationFromLocalStorage() || null;
};
export var CurrentOrganization = {
    getId: getId
};

//# sourceMappingURL=CurrentOrganization.js.map